var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{staticClass:"el-menu-demo",attrs:{"default-active":_vm.activeIndex,"mode":"horizontal","background-color":"#231544","text-color":"#fff","router":"","active-text-color":"#fff"}})
}
var staticRenderFns = []

export { render, staticRenderFns }